import type { WelcomeBonusCampaignBonus } from '../../../../../@types/api';
import { CAMPAIGN_REWARD_TYPE } from '../../../../../constants/enums';
import type { WelcomeBonusCreateFormData } from '../../../../../schema';
import { RequiredSportsbookWageringFields } from '../WageringFields';
import {
  WelcomeBonusFormSection,
  WelcomeBonusReviewField,
  WelcomeBonusReviewGrid,
} from '../WelcomeBonusFormPrimitives';

export const getSportsbookProductDefaults = () =>
  ({
    rewardType: CAMPAIGN_REWARD_TYPE.REAL_MONEY,
    minSelections: 1,
    minOddsPerSelection: 1,
    maxBetLimit: null,
    gameWeightingContributions: [],
    incrementalUnlocksEnabled: false,
    unlockBatchPercentage: null,
  }) satisfies Partial<WelcomeBonusCreateFormData>;

export const buildSportsbookProductPayload = (data: WelcomeBonusCreateFormData) => ({
  minSelections: data.minSelections,
  minOddsPerSelection: data.minOddsPerSelection,
});

export const SportsbookCreateFields = () => (
  <WelcomeBonusFormSection title='Sportsbook settings'>
    <RequiredSportsbookWageringFields />
  </WelcomeBonusFormSection>
);

type SportsbookReviewFieldsProps = {
  campaignBonus?: WelcomeBonusCampaignBonus | null;
};

export const SportsbookReviewFields = ({ campaignBonus }: SportsbookReviewFieldsProps) => (
  <WelcomeBonusFormSection title='Sportsbook settings'>
    <WelcomeBonusReviewGrid>
      <WelcomeBonusReviewField label='Min. Selections number' value={campaignBonus?.minSelections} />
      <WelcomeBonusReviewField label='Min. Odds of each selection' value={campaignBonus?.minOddsPerSelection} />
    </WelcomeBonusReviewGrid>
  </WelcomeBonusFormSection>
);
